module.exports = __webpack_public_path__ + "static/media/evaluation.86f90a15.png";